import { retaxKernel } from 'retax';
import { componentsModule, ANNOTATOR } from './inversify';
retaxKernel.load(componentsModule);
export const annotator = retaxKernel.get(ANNOTATOR);
export { AbstractActionsCreator } from './actionsCreator';
export { AbstractApi } from './api';
export { AbstractLifecycleManager } from './lifecycle';
